<div [formGroup]="parentForm" id="input-control-container"
  [attr.data-testid]="inputControlModel.controlName + '-input-container'">

  <mm-control-label [controlName]="inputControlModel.controlName" [label]="inputControlModel.label"
    [hasError]="hasError" [hasGreyText]="inputControlModel.hasGreyText" [greyText]="inputControlModel.greyText"
    [displayInlineTooltip]="inputControlModel.hasInlineTooltip ? true : false"
    [displayIconTooltip]="inputControlModel.hasIconTooltip ? true : false" [tooltip]="inputControlModel.tooltip"
    id="input-control-label" [secondLineGreyText]="secondLineGreytext">
  </mm-control-label>

  <div class="input-container">
    <input trimControl id="{{inputControlModel.controlName}}" [attr.data-testid]="inputControlModel.controlName + '-input'"
      name="{{inputControlModel.controlName}}" [class.error-input]="hasError"
      class="sdps-input sdps-input--small input-control-text" type="text" [attr.title]="setHoverValue ? control?.value : null"
      formControlName="{{inputControlModel.controlName}}" [attr.maxlength]="inputControlModel.htmlMaxLength" [attr.placeholder]="placeholder"
      (keydown)="inputControlModel.allowedChars ? validationService.validateNumberInput($event, inputControlModel.allowedChars) : null"
      (blur)="blur.emit()">
    <i *ngIf="(control?.value || control?.dirty) && !control?.disabled" (click)="clearField(control)" class="sch-thin-x"
      [attr.data-testid]="'clear-x-' + inputControlModel.controlName"></i>
  </div>

  <div class="error-text" [attr.data-testid]="inputControlModel.controlName + '-error-text'"
    id="{{inputControlModel.controlName + '-error-text'}}" *ngIf="hasError">
    {{errorMessage}}
  </div>

</div>